<already-register>
  <p></p>

  <div class="uk-text-center">
    <div class="step">
      <span class="title">BeatFitへようこそ</span><br />
      <span class="explain">このアカウントは既に有効です。<br />スマートフォンでアプリをダウンロードすれば、すぐに使い始められます。</span>
    </div>

    <div class="uk-margin-large-top">
      <a href="https://itunes.apple.com/jp/app/beatfit-%E3%83%91%E3%83%BC%E3%82%BD%E3%83%8A%E3%83%AB%E3%83%88%E3%83%AC%E3%83%BC%E3%83%8B%E3%83%B3%E3%82%B0%E3%82%92%E5%AE%9A%E9%A1%8D%E8%81%B4%E3%81%8D%E6%94%BE%E9%A1%8C%E3%81%A7/id1346631395?mt=8" target="_blank">
        <img class="appstore" src="/image/appstore.png" />
      </a>
      <a href="https://play.google.com/store/apps/details?id=jp.beatfit" target="_blank">
        <img class="googleplay" src="/image/googleplay.png" />
      </a>
    </div>

    <div class="uk-margin-large-top">
      <span class="notes">ご登録いただいたメールアドレスとパスワードでログインして<br />BeatFitのクラスをお楽しみください。</span>
    </div>
  </div>

  <script>
    var self = this
  </script>
</already-register>
